import React from 'react';
import AppShell from '../shell/AppShell';
import TermsPage from '../../screens/TermsPage';

/**
 * /unified/terms — terms of service inside the unified shell. Public page,
 * no auth gate.
 */
export default function UnifiedTerms() {
  return (
    <AppShell dense>
      <div className="cwm-unified-mui-wrap">
        <TermsPage />
      </div>
    </AppShell>
  );
}
